export enum TSSprache {
    DEUTSCH = <any> 'DEUTSCH',
    FRANZOESISCH = <any> 'FRANZOESISCH',
    ITALIENISCH = <any> 'ITALIENISCH'
}

export function getTSSpracheValues(): Array<TSSprache> {
    return [
        TSSprache.DEUTSCH,
        TSSprache.FRANZOESISCH,
        TSSprache.ITALIENISCH,
    ];
}

export function getLanguageMap(): Map<string, TSSprache> {
    let map: Map<string, TSSprache> = new Map<string, TSSprache>();
    map.set('de', TSSprache.DEUTSCH);
    map.set('fr', TSSprache.FRANZOESISCH);
    map.set('it', TSSprache.ITALIENISCH);
    return map;
}

export function getLanguageByKey(key: string): TSSprache {
    let map = getLanguageMap();
    let returnValue = map.get(key);

    if (returnValue) {
        return returnValue;
    } else {
        return TSSprache.DEUTSCH;
    }

}




// WEBPACK FOOTER //
// ./src/app/models/enums/TSSprache.ts